import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class RejectCommon extends Vue {
    @Prop() visible: false
    @Prop() data: {
        // isFirstNode: false;
        // isSyncEkuaibao: false;
        // approvalStatus: 0;
    }
    @Prop() isContract: false
    @Prop() isCommison: false
    @Prop() isRefund: false
    @Prop() isMarketCost: false

    approvalOptions = [
        {label: '第一个', value: '0'},
        {label: '当前', value: '1'}
    ]

    isTouchEOptions = [
        {label: '否', value: '0'},
        {label: '是', value: '1'},
    ]

    disBtn = false
    isFirstNode = false
    isSyncEkuaibao = false
    isSyncEqianbao = false
    status = 0
    formData = {
        reviewIdea: '',
        rejectNode: '0',
        isTouchE: '0',
        isTouchEQ: '0',
    }

    //
    created() {

        this.isFirstNode = (this.data as any).isFirstNode
        this.isSyncEkuaibao = (this.data as any).isSyncEkuaibao
        this.isSyncEqianbao = (this.data as any).isSyncEqianbao
        if (this.isFirstNode === true) {
            this.formData.rejectNode = '0'
        }
        // if (this.isSyncEkuaibao === true) {
        //     this.formData.isTouchE = '1'
        // }
        if (this.isSyncEqianbao === true) {
            this.formData.isTouchEQ = '1'
        }
    }

    /*
    * methods*/
    closeReviewDialog() {
        this.formData.reviewIdea = ''
        this.formData.rejectNode = ''
        this.formData.isTouchE = ''
        this.formData.isTouchEQ = ''
        this.$emit('handleClose', false)
    }

    confirmReviewDialog() {
        this.$emit('doConfirm',this.formData)
    }
}
